import { gql, useQuery } from "@apollo/client";
import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  WrapItem,
  Image,
  Skeleton,
  Wrap,
} from "@chakra-ui/react";
import { setTexture } from "../../../Store/ConstructorReducer";
import { useAppDispatch, useAppSelector } from "../../../Store/hooks";
import {
  ModalsName,
  setModalOpen,
} from "../../../Store/ModalsReducer";
import { colors } from "../../../Theme";
import LoaderFullwidth from "../../Helpers/LoaderFullwidth";

const LOAD_TEXTURES = gql`
  query LoadTextures($page: Int) {
    textures(page: $page, only3d:true) {
      items {
        id
        name
        preview
        file3d
      }
      total
    }
  }
`;

interface ITexture {
  id: number;
  name: string;
  preview: string;
  file3d: string;
}

const TextureItem = (props: ITexture) => {
  const key = useAppSelector((state) => state.modals[ModalsName.TEXTURES].key);
  const dispatch = useAppDispatch();
  return (
    <WrapItem
      onClick={() => {
        dispatch(setTexture({ key, texture: props.file3d }));
        dispatch(setModalOpen({ key: ModalsName.TEXTURES, value: false }));
      }}
    >
      <Box w={200} h={175} textAlign="center" border="#333 1px solid">
        <>
          <Text w={198} h={25} bg="#333" color="white" fontWeight="bold">
            {props.name}
          </Text>
          <Box w={198} h={148} align="center">
            <Image
              src={props.preview}
              alt={props.name}
              w={198}
              h={148}
              fallback={<Skeleton w={200} h={150} />}
            />
          </Box>
        </>
      </Box>
    </WrapItem>
  );
};

const ModalTextures = () => {
  const isOpen = useAppSelector(
    (state) => state.modals[ModalsName.TEXTURES].isOpen
  );
  const dispatch = useAppDispatch();

  const { data, loading, error } = useQuery(LOAD_TEXTURES);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() =>
          dispatch(setModalOpen({ key: ModalsName.TEXTURES, value: false }))
        }
        size="custom"
        isCentered={true}
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent maxH="80vh" w="80vw" bg={colors.badgeLight}>
          <ModalCloseButton />
          <ModalBody marginTop="4rem">
            <Wrap justify="space-evenly">
              {error && <Text color="red">{error.message}</Text>}
              {loading && <LoaderFullwidth />}
              {data &&
                data.textures.items.filter((texture:ITexture) => texture.file3d.length > 0).map((texture: ITexture) => (
                  <TextureItem {...texture} key={`texture-${texture.id}`} />
                ))}
            </Wrap>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalTextures;
